import axios from 'axios'
import { API_URL } from 'services/config'
import { PhysicalPerson, LegalPerson } from 'models/Person'
// import SelectOption from 'models/SelectOption'
import Paginator from 'models/Paginator'
import CommonDataStore from 'stores/CommonDataStore'

class ClientsService {
    getClients = (params) =>
        axios.get(`${API_URL}/customers`, { params }).then(({ data: { data, pagination } }) => {
            return {
                clients: data.map((client) => {
                    if (CommonDataStore.isLegalPerson(client.type)) {
                        return LegalPerson.fromJson(client)
                    }
                    if (CommonDataStore.isPhysicalPerson(client.type)) {
                        return PhysicalPerson.fromJson(client)
                    }
                    return null
                }),
                paginator: Paginator.fromJson(pagination),
            }
        })

    getClientData = (clientId) =>
        axios.get(`${API_URL}/customers/${clientId}`).then(({ data }) => {
            if (CommonDataStore.isLegalPerson(data.data.type)) {
                return LegalPerson.fromJson(data.data)
            }

            if (CommonDataStore.isPhysicalPerson(data.data.type)) {
                return PhysicalPerson.fromJson(data.data)
            }

            return null
        })

    createClient = (data) => axios.post(`${API_URL}/customers`, data).then((response) => response)

    updateClient = (customerId, data) => {
        return axios
            .post(`${API_URL}/customers/${customerId}/edit`, data)
            .then((response) => response)
    }

    fromStorage() {
        return this
    }
}

export default ClientsService
